import { Popper } from "@/contexts/ActionPopperContext";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import { useRef } from "react";

interface PopperProps extends Popper {
  handleClose: () => void;
}

const PopperAction = ({ data, actions = [], handleClose }: PopperProps) => {
  const ref = useRef(null);
  useOnClickOutside(ref, handleClose);

  return (
    <Paper ref={ref}>
      <List>
        {actions.map((action) => (
          <ListItem
            disabled={action.disabled}
            key={action.title}
            onClick={() => !action.disabled && action?.handler(data)}
            sx={{
              height: 38,
              ":hover": { bgcolor: "grey.100", cursor: "pointer" },
            }}
          >
            {action.icon && (
              <ListItemIcon sx={{ minWidth: "30px", mr: 1 }}>
                {action?.icon}
              </ListItemIcon>
            )}
            <ListItemText primary={action.title} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default PopperAction;
